export const getVerboseName = (vehicle: any) => {
  const { make, model, year } = vehicle || {};
  if (!make || !model || !year) return "";
  const displayMake = typeof make === "string" ? make : make.name;
  const displayModel = typeof model === "string" ? model : model.name;
  return `${displayMake} ${displayModel} ${year}`;
};
